import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export default function AutocompleteLoader({ params, loader }) {
  return (
    <React.Fragment>
      {loader ? (
        <CircularProgress
          color="inherit"
          size={20}
          sx={{ marginRight: '31px' }}
        />
      ) : null}
      {params.InputProps.endAdornment}
    </React.Fragment>
  );
}
